var map = {
	"./FileIcon.png": 62290,
	"./accordion-minus.svg": 5489,
	"./accordion-plus.svg": 19018,
	"./account.svg": 25067,
	"./activate-tarif-icon.svg": 69680,
	"./apple-logo.svg": 82403,
	"./author-logo.svg": 29379,
	"./back-newyear.png": 7309,
	"./banners/background-banner-gpt.png": 21765,
	"./banners/background-banner-tasks.png": 29664,
	"./banners/background-tg-logo.png": 3805,
	"./banners/background-tg.png": 87383,
	"./banners/path-to-victory.jpg": 9522,
	"./banners/ww2-anniversary-80.png": 1916,
	"./bell-notification.svg": 42028,
	"./bg.jpg": 48496,
	"./book-text-example.png": 25110,
	"./book.svg": 71323,
	"./books/b1.webp": 73234,
	"./books/b2.webp": 28821,
	"./books/b3.jpg": 82216,
	"./books/b4.jpg": 83852,
	"./books/book-example.jpg": 69723,
	"./books/not-loaded-book.png": 2842,
	"./books/not-loaded-book2.png": 39619,
	"./bot_avatar.png": 24722,
	"./bronze-prize.svg": 79604,
	"./calculator-plus.svg": 90295,
	"./card-tip1.svg": 69844,
	"./change-avatar.svg": 28042,
	"./coins.png": 44397,
	"./delete-avatar.png": 36465,
	"./delete-avatar.svg": 93120,
	"./device-mac.svg": 34064,
	"./dropdown-icon.svg": 65314,
	"./errors/sadcat.webp": 38099,
	"./fav-button-active-hover.svg": 820,
	"./fav-button-filled.svg": 78165,
	"./fav-button-hover.svg": 43700,
	"./fav-button.svg": 54873,
	"./gold-prize.svg": 63043,
	"./google-logo.svg": 64998,
	"./headings/backpack.png": 6110,
	"./headings/rocket.png": 5102,
	"./icon-premium.svg": 928,
	"./image72.svg": 250,
	"./instructionNums/1.png": 28753,
	"./instructionNums/2.png": 52072,
	"./instructionNums/3.png": 87900,
	"./instructionNums/4.png": 14381,
	"./instructionNums/5.png": 48105,
	"./instructionNums/6.png": 27665,
	"./join_kazatel.svg": 27556,
	"./kazatel-green-logo.svg": 81001,
	"./kazatel-logo.svg": 65077,
	"./kazatel-newyear.svg": 44670,
	"./letter-icon.svg": 20615,
	"./locked_content.png": 68127,
	"./logo.png": 74427,
	"./logo.svg": 82835,
	"./menu-archive.svg": 56046,
	"./menu-exit.svg": 88924,
	"./menu-home.svg": 78471,
	"./menu-monitization.svg": 94683,
	"./menu-notification-bell.svg": 26991,
	"./menu-notification.svg": 81021,
	"./menu-payments.svg": 23894,
	"./menu-processes.svg": 66114,
	"./menu-profile.svg": 95759,
	"./menu-settings.svg": 88845,
	"./menu-templates.svg": 57035,
	"./menu-user-phote.png": 93729,
	"./menu-user-photo-big.png": 68968,
	"./menu-user-photo.png": 54929,
	"./menu-vertical-line.svg": 49639,
	"./menu.svg": 28647,
	"./microphone.svg": 85136,
	"./moderator.png": 23163,
	"./number.svg": 11612,
	"./ok.svg": 87026,
	"./paper.svg": 33775,
	"./paragraph-example.png": 20450,
	"./partners/partner_id_1.png": 3276,
	"./partners/partner_id_10.png": 20162,
	"./partners/partner_id_2.png": 84753,
	"./partners/partner_id_3.png": 52354,
	"./partners/partner_id_4.png": 40950,
	"./partners/partner_id_5.png": 4074,
	"./partners/partner_id_6.png": 18399,
	"./partners/partner_id_7.png": 91455,
	"./partners/partner_id_8.png": 53031,
	"./partners/partner_id_9.png": 30747,
	"./password-eye-closed.svg": 82066,
	"./password-eye-opened.svg": 70988,
	"./payment-card-master-card.svg": 26001,
	"./payment-card-mir.svg": 11892,
	"./payment-card-visa.svg": 22303,
	"./payment-icon.svg": 45976,
	"./payment-system-master-card.svg": 74229,
	"./payment-system-mir.svg": 2024,
	"./payment-system-visa.svg": 33183,
	"./player-example.png": 53289,
	"./plug-background.png": 44763,
	"./plug-premium-background.png": 47255,
	"./profile-image-plug.png": 62894,
	"./progress-bar-line.svg": 46670,
	"./rectangle.png": 21749,
	"./rectangle.svg": 43420,
	"./silver-prize.svg": 86446,
	"./solution-task-example.png": 41603,
	"./source-task-example.png": 66986,
	"./subheader-icons/icon-for-not-found.svg": 50208,
	"./subheader-icons/icon_id_1.svg": 9331,
	"./subheader-icons/icon_id_2.svg": 60009,
	"./subheader-icons/icon_id_3.svg": 14795,
	"./subheader-icons/icon_id_4.svg": 8487,
	"./subheader-icons/icon_id_5.svg": 63056,
	"./subheader-icons/icon_id_6.svg": 73230,
	"./subheader-icons/icon_id_7.svg": 49366,
	"./subject-icon.png": 78191,
	"./subject-icons/icon-for-1.svg": 57575,
	"./subject-icons/icon-for-10.svg": 74252,
	"./subject-icons/icon-for-11.svg": 13054,
	"./subject-icons/icon-for-12.svg": 91714,
	"./subject-icons/icon-for-13.svg": 59985,
	"./subject-icons/icon-for-14.svg": 75007,
	"./subject-icons/icon-for-15.svg": 13058,
	"./subject-icons/icon-for-16.svg": 53894,
	"./subject-icons/icon-for-17.svg": 98065,
	"./subject-icons/icon-for-18.svg": 91157,
	"./subject-icons/icon-for-19.svg": 10392,
	"./subject-icons/icon-for-2.svg": 65194,
	"./subject-icons/icon-for-20.svg": 60325,
	"./subject-icons/icon-for-21.svg": 44839,
	"./subject-icons/icon-for-22.svg": 16597,
	"./subject-icons/icon-for-23.svg": 80207,
	"./subject-icons/icon-for-24.svg": 56639,
	"./subject-icons/icon-for-25.svg": 92401,
	"./subject-icons/icon-for-26.svg": 75244,
	"./subject-icons/icon-for-27.svg": 19993,
	"./subject-icons/icon-for-28.svg": 46061,
	"./subject-icons/icon-for-29.svg": 97935,
	"./subject-icons/icon-for-3.svg": 6090,
	"./subject-icons/icon-for-4.svg": 75812,
	"./subject-icons/icon-for-5.svg": 5251,
	"./subject-icons/icon-for-6.svg": 23753,
	"./subject-icons/icon-for-7.svg": 56076,
	"./subject-icons/icon-for-8.svg": 80582,
	"./subject-icons/icon-for-9.svg": 24812,
	"./subject-icons/icon-for-not-found.svg": 96808,
	"./subject-images/subject_type_1.png": 56693,
	"./subject-images/subject_type_15.png": 92297,
	"./subject-images/subject_type_2.png": 22019,
	"./subject-images/subject_type_23.png": 13351,
	"./subject-images/subject_type_24.png": 41213,
	"./subject-images/subject_type_25.png": 26367,
	"./subject-images/subject_type_27.png": 21854,
	"./subject-images/subject_type_3.png": 32093,
	"./subject-images/subject_type_5.png": 70150,
	"./subject-images/subject_type_8.png": 36762,
	"./subject-images/subject_type_unknown.png": 24272,
	"./subjects/subject_type_algebra_HD.png": 23680,
	"./subjects/subject_type_biology_HD.png": 50577,
	"./subjects/subject_type_chemistry_HD.png": 84688,
	"./subjects/subject_type_english_HD.png": 51424,
	"./subjects/subject_type_geometry_HD.png": 95896,
	"./subjects/subject_type_it_HD.png": 73718,
	"./subjects/subject_type_math_HD.png": 31959,
	"./subjects/subject_type_physics_HD.png": 93356,
	"./subjects/subject_type_tech_HD.png": 34864,
	"./subjects/subject_type_unknown_HD.png": 76009,
	"./tarif-base.svg": 22873,
	"./tarif-detailed-header-base.svg": 50440,
	"./tarif-detailed-header-extended.svg": 30088,
	"./tarif-detailed-header-full.svg": 41774,
	"./tarif-extended.svg": 94559,
	"./tarif-full.svg": 69445,
	"./tarifs-icon.svg": 66946,
	"./task-entity-title-background.svg": 31629,
	"./task-solution-example.png": 56544,
	"./task-statement-example.png": 29900,
	"./tasks/no-tasks.png": 39626,
	"./tasks/u2591.png": 74559,
	"./telegram-logo.svg": 2133,
	"./user-email.svg": 40242,
	"./user-location.svg": 85545,
	"./video.svg": 5559,
	"./vk-logo.svg": 845,
	"./wow-bg.svg": 27547,
	"./yandex-logo.svg": 16718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;